import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class CustQueryCriteriaClass extends BaseCriteriaModel {
  //For bl_fi_mst_entity_hdr table
  name?: Optional<string> = Optional.empty();
  hdr_name?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  hdr_guids?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  //For lines and ext
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
  ext_created_date?: Optional<string> = Optional.empty();
  ext_updated_date?: Optional<string> = Optional.empty();
  ext_status?: Optional<string> = Optional.empty();
  entity_ext_guid?: Optional<string> = Optional.empty();
}

export class CustCriteriaModelQuery {
  query = '';

  constructor(custCriteriaModel: CustQueryCriteriaClass) {
    console.log('custCriteriaModel', custCriteriaModel);

    if (!custCriteriaModel) {
      return;
    }

    this.query += custCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += custCriteriaModel.hdr_name.filter(x => x !== '').map(x => '&hdr_name=' + x).orElse('');
    this.query += custCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += custCriteriaModel.hdr_guids.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');

    this.query += custCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += custCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += custCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += custCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += custCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += custCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');
    this.query += custCriteriaModel.ext_created_date.filter(x => x !== '').map(x => '&ext_created_date=' + x).orElse('');
    this.query += custCriteriaModel.ext_updated_date.filter(x => x !== '').map(x => '&ext_updated_date=' + x).orElse('');
    this.query += custCriteriaModel.ext_status.filter(x => x !== '').map(x => '&ext_status=' + x).orElse('');
    this.query += custCriteriaModel.entity_ext_guid.filter(x => x !== '').map(x => '&entity_ext_guid=' + x).orElse('');


    this.query += '&status=' + custCriteriaModel.status;
    this.query += '&orderBy=' + custCriteriaModel.orderBy;
    this.query += '&order=' + custCriteriaModel.order;
    this.query += '&offset=' + custCriteriaModel.offset + '&limit=' + custCriteriaModel.limit;
  }

}
